import React from 'react';

const PaginationMoreButton = ({ handlePagination, url }) => {
	return (
		<li className="mx-1">
			<a
				href={url}
				aria-label="Next Page"
				onClick={(e) => {
					e.preventDefault();
					handlePagination(url);
				}}
				className="pagination__list-item-link text-cta-action"
				data-testid="pagination-more">
				<div className="text-base">
					<i className="ico ico-chevron-right ico-lg text-cta-action" />
				</div>
			</a>
		</li>
	);
};

export default PaginationMoreButton;
